import {
  Badge,
  Button,
  Divider,
  HStack,
  Icon,
  Stack,
  StackDivider,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { BsEnvelopeFill, FaExclamationCircle } from 'react-icons/all';
import { useRoleCan } from '~/hooks';
import { SideModal } from '~/components/SideModal';
import { Heading } from '~/components';
import { useAnnouncementsNotification } from '~/hooks/useAnnouncements';
import { AnnouncementDialog } from '~/components/AnnouncementDialog';
import {
  AnnouncementsStatusCliente,
  AnnouncementsView,
} from '~/types/announcements';
import { setarStatusLidoAnnouncement } from '~/services/Announcements';

export const Notification: React.FC = () => {
  const userIsAdmin = useRoleCan({ roles: ['administrador'] });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenModal,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();
  const toast = useToast();
  const [isFetching, setIsFetching] = useState(false);
  const [hasNotifications, setHasNotifications] = useState(false);
  const [comunicadoSelecionado, setComunicadoSelecionado] =
    useState<AnnouncementsView>({} as AnnouncementsView);
  const { data, isLoading, refetch } = useAnnouncementsNotification();
  useEffect(() => {
    setaHasNotificacoes();
  }, [data]);

  window.addEventListener('comunicado-lido', () => {
    refetch();
  });

  const setaHasNotificacoes = () => {
    const possuiNotificacoes =
      data?.some(
        it => it.status_cliente === AnnouncementsStatusCliente.NAO_LIDO,
      ) || false;
    setHasNotifications(possuiNotificacoes);
  };

  const abriModalComunicado = (comunicado: AnnouncementsView) => {
    setComunicadoSelecionado(comunicado);
    onOpenModal();
  };

  const setarStatusLido = () => {
    setIsFetching(true);
    setarStatusLidoAnnouncement(comunicadoSelecionado.id!)
      .then(() => {
        comunicadoSelecionado.status_cliente = AnnouncementsStatusCliente.LIDO;
        setaHasNotificacoes();
        const event = new CustomEvent('comunicado-lido-notificacao');
        window.dispatchEvent(event);
        onCloseModal();
      })
      .catch(() => null)
      .finally(() => setIsFetching(false));
  };

  return (
    <>
      {!userIsAdmin && (
        <>
          <HStack justifyContent="center" gridGap={0}>
            <Icon
              as={BsEnvelopeFill}
              onClick={onOpen}
              cursor="pointer"
              color="white"
              size="md"
            />
            {hasNotifications && (
              <Badge
                colorScheme="red"
                variant="solid"
                borderRadius="10px"
                w="6px"
                h="8px"
                marginLeft="-3px !important"
                marginTop="-12px !important"
              />
            )}
          </HStack>
          <SideModal titulo="Mural de avisos" isOpen={isOpen} onClose={onClose}>
            <Stack gridGap={3} py={3}>
              <Stack
                margin="0px !important"
                divider={
                  <StackDivider
                    borderColor="gray.200"
                    margin="0px !important"
                  />
                }
              >
                {data?.length ? (
                  data.map((comunicado, index) => (
                    <HStack
                      key={comunicado.id}
                      gridGap={3}
                      padding={3}
                      backgroundColor={
                        comunicado.status_cliente ===
                        AnnouncementsStatusCliente.NAO_LIDO
                          ? 'red.50'
                          : ''
                      }
                      alignItems="baseline"
                      cursor="pointer"
                      onClick={() => abriModalComunicado(comunicado)}
                    >
                      <Stack>
                        {comunicado.status_cliente ===
                          AnnouncementsStatusCliente.NAO_LIDO && (
                          <Icon as={FaExclamationCircle} color="red.400" />
                        )}
                      </Stack>
                      <Stack>
                        <Heading>{comunicado.titulo}</Heading>
                        <Text
                          dangerouslySetInnerHTML={{
                            __html: comunicado.formattedMensage,
                          }}
                        />
                        <Text>
                          <b>Data de publicação:</b> {comunicado.formattedDate}
                        </Text>
                      </Stack>
                    </HStack>
                  ))
                ) : (
                  <Text>Nenhum comunicado encontrado</Text>
                )}
              </Stack>
              <Divider borderColor="gray.200" />
              <HStack justifyContent="flex-end">
                <Button onClick={onClose} textAlign="right">
                  Fechar
                </Button>
              </HStack>
            </Stack>
          </SideModal>
          <AnnouncementDialog
            isOpenModal={isOpenModal}
            onCloseModal={onCloseModal}
            status={comunicadoSelecionado.status_cliente}
            exigirCiencia={comunicadoSelecionado.exigir_ciencia}
            motivoCancelamento={comunicadoSelecionado.motivo_cancelamento}
            dataPublicacao={comunicadoSelecionado.formattedDateTime!}
            titulo={comunicadoSelecionado.titulo}
            mensagem={comunicadoSelecionado.mensagem}
            arquivos={comunicadoSelecionado.arquivos}
            setarStatusLido={setarStatusLido}
            isFetching={isFetching}
          />
        </>
      )}
    </>
  );
};
